
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shitty-map",
      function () {
        return require("private-next-pages/shitty-map/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shitty-map"])
      });
    }
  